import { useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import {
    Box,
    Button,
    Divider,
    // Hidden,
    List,
    ListItem,
    ListItemText,
    Popover,
    Typography,
    styled
} from '@mui/material';

import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';

import { logoutAuth } from 'src/auth';

const UserBoxButton = styled(Button)(
    ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
    ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
    ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
    ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.primary.main};
        display: block;
`
);

function HeaderUserbox() {
    const navigate = useNavigate();
    const usuario = JSON.parse(localStorage.getItem('USUARIO'));
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const perfil = () => {
        setOpen(false);
        navigate('/dashboard/perfil');
    }

    const cerrarSesion = () => {
        logoutAuth();
        window.location.reload();
    }

    return (
        <>
            <UserBoxButton color="primary" ref={ref} onClick={handleOpen}>
                <UserBoxText
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        maxWidth: { xs: 120, sm: 160, md: '100%' },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    <UserBoxLabel variant="body1">
                        {usuario.fields.nombre_completo}
                    </UserBoxLabel>
                </UserBoxText>

                <Box sx={{ display: { xs: 'none', sm: 'flex' }, ml: 1 }}>
                    <ExpandMoreTwoToneIcon />
                </Box>
            </UserBoxButton>
            <Popover
                anchorEl={ref.current}
                onClose={handleClose}
                open={isOpen}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <MenuUserBox sx={{ minWidth: 210 }} display="flex">
                    <UserBoxText>
                        <UserBoxLabel variant="body1">{usuario.fields.nombre}</UserBoxLabel>
                    </UserBoxText>
                </MenuUserBox>
                <Divider sx={{ mb: 0 }} />
                <List sx={{ p: 1 }} component="nav">
                    <ListItem button onClick={perfil}>
                        <AccountBoxTwoToneIcon fontSize="small" />
                        <ListItemText primary="Mi Perfil" />
                    </ListItem>
                </List>
                <Divider />
                <Box sx={{ m: 1 }}>
                    <Button
                        onClick={cerrarSesion}
                        color="primary"
                        fullWidth
                    >
                        <LockOpenTwoToneIcon sx={{ mr: 1 }} />
                        Salir
                    </Button>
                </Box>
            </Popover>
        </>
    );
}

export default HeaderUserbox;
